export default (state = [], action) => {
	switch (action.type){
		case 'FETCH_ARTIST':
			return [...state, action.payload];

		default:
			return state;
	}
}